import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { posKitOrder, validateOrder } from "../../services/posOrders";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const PagoConfirmacion = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const finalizarPedido = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const wpCancel = params.get("wp_cancel");

      if (!code && !wpCancel) return;

      if (code === "1") {
        const tempData = JSON.parse(localStorage.getItem("kit_temp_order"));
        if (!tempData) return;

        try {
          const orderId = await posKitOrder(
            tempData.userData,
            tempData.line,
            tempData.discountProducts,
            tempData.additionalProducts
          );
          const ID = await validateOrder(orderId);

          localStorage.removeItem("kit_temp_order");

          navigate("/kits/confirmation", {
            state: {
              orderId: ID.name,
              totalPrice: tempData.totalPrice
            },
          });
        } catch (error) {
          console.error("Error finalizando orden tras pago:", error);
        }
      } else if (wpCancel === "yes") {
        alert("El pago fue cancelado por el usuario.");
        localStorage.removeItem("kit_temp_order");
        navigate("/kits");
      } else {
        alert("Pago fallido o incompleto.");
        localStorage.removeItem("kit_temp_order");
        navigate("/kits");
      }
    };

    finalizarPedido();
  }, [navigate]);

  return (
    <div className="confirmation-container">
      <Header />
      <div className="confirmation-content">
        <h1>Verificando pago...</h1>
        <p>Espere mientras procesamos su orden.</p>
      </div>
      <Footer />
    </div>
  );
};

export default PagoConfirmacion;
